/* hpl-teilen · Verhalten des Teilen-Knopfs, Markup in snippets/hpl-teilen.liquid */
(function () {
  var el = document.querySelector('[data-hpl-teilen]');
  if (!el || el.hplBereit) return;
  el.hplBereit = true;

  var url = el.getAttribute('data-url');
  var titel = el.getAttribute('data-titel');
  var details = el.querySelector('details');
  var summary = el.querySelector('summary');
  var kopieren = el.querySelector('[data-t-kopieren]');
  var kopierenText = el.querySelector('[data-t-kopieren-text]');

  /* Handy: Teilen-Menü des Telefons. Am Computer bleibt die Auswahl, dort taugt das System-Menü wenig. */
  var nativ = !!navigator.share && window.matchMedia('(pointer: coarse)').matches;

  summary.addEventListener('click', function (e) {
    if (!nativ) return;
    e.preventDefault();
    navigator.share({ title: titel, url: url }).catch(function (err) {
      if (err && err.name !== 'AbortError') details.open = true;
    });
  });

  /* Fallback auch bei Ablehnung: In-App-Browser (Instagram, Facebook) sperren die Zwischenablage-API oft. */
  function linkKopieren(text) {
    if (!navigator.clipboard || !navigator.clipboard.writeText) return altKopieren(text);
    return navigator.clipboard.writeText(text).catch(function () { return altKopieren(text); });
  }

  function altKopieren(text) {
    return new Promise(function (ok, nein) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var geklappt = false;
      try { geklappt = document.execCommand('copy'); } catch (x) {}
      ta.remove();
      if (geklappt) ok(); else nein(new Error('kopieren'));
    });
  }

  var kopierenTimer;
  kopieren.addEventListener('click', function () {
    linkKopieren(url).then(function () {
      kopierenText.textContent = kopierenText.dataset.tKopiert || 'Link kopiert';
    }).catch(function () {
      kopierenText.textContent = kopierenText.dataset.tFehler || 'Kopieren ging nicht';
    }).then(function () {
      clearTimeout(kopierenTimer);
      kopierenTimer = setTimeout(function () { kopierenText.textContent = kopierenText.dataset.tStart || 'Link kopieren'; }, 2500);
    });
  });

  document.addEventListener('click', function (e) {
    if (details.open && !details.contains(e.target)) details.open = false;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && details.open) { details.open = false; summary.focus(); }
  });

  /* Story-Bild: nur für Geräte, die einmal ?story=1 aufgerufen haben. */
  function storyAn() {
    var wert = new URLSearchParams(location.search).get('story');
    try {
      if (wert === '1') localStorage.setItem('hpl_story', '1');
      if (wert === '0') localStorage.removeItem('hpl_story');
      if (wert === null) return localStorage.getItem('hpl_story') === '1';
    } catch (x) {}
    return wert === '1';
  }
  if (!storyAn()) return;

  var knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = 'hpl-teilen__k';
  knopf.textContent = 'Story-Bild';
  el.insertBefore(knopf, details);

  var geladen;
  function storyLaden() {
    if (!geladen) {
      geladen = new Promise(function (ok, nein) {
        var s = document.createElement('script');
        s.src = el.getAttribute('data-story-js');
        s.onload = ok;
        s.onerror = nein;
        document.head.appendChild(s);
      });
    }
    return geladen;
  }
  knopf.addEventListener('click', function () {
    storyLaden().then(function () {
      window.hplStoryOeffnen({
        url: url,
        handle: el.getAttribute('data-handle'),
        logo: el.getAttribute('data-logo'),
        kopieren: linkKopieren
      });
    });
  });
})();
